@if (header == null) {
  <portal-card class="card--no-body">
    <ng-container header>
      <h2>{{ title | portalTranslate }}</h2>
    </ng-container>
    <ng-container actions>
      <!-- Add new entry -->
      @if (canAddOrDelete) {
        <portal-icon-button
          [disabled]="loading"
          [portalTippy]="'generic.add.entry' | translate"
          (onClick)="triggerAdd()"
        ></portal-icon-button>
      }
      <!-- Refresh entries -->
      <portal-icon-button
        [loading]="loading"
        [portalTippy]="'generic.reload' | translate"
        (onClick)="refresh()"
        iconClass="far fa-sync"
      ></portal-icon-button>
    </ng-container>
  </portal-card>
} @else {
  <ng-container
    *ngTemplateOutlet="
      header;
      context: { add: triggerAdd, canAdd: canAddOrDelete, loading: loading, refresh: refresh }
    "
  ></ng-container>
}

<portal-loading-indicator-container [loading]="loading">
  <div class="container-fluid p-0">
    <div class="row">
      @for (contactGroup of contactGroups; track contactGroup) {
        <portal-card
          class="col-12 col-md-6 col-xl-4 card--highlight-on-hover"
          (click)="triggerEdit(contactGroup)"
        >
          <h2 header>
            @if (isFavorite(contactGroup) === false) {
              {{ contactGroup.name }}
            } @else {
              <span>
                <i class="far fa-star"></i>
                <span class="ms-1">{{ 'phoneBook.contact.group.favourites' | translate }}</span>
              </span>
            }
          </h2>
          @if (isFavorite(contactGroup) === false && canAddOrDelete) {
            <ng-container actions>
              <portal-dropdown-menu [preventAndStop]="true" placement="bottom-right">
                <!-- Remove entry -->
                <button
                  (click.prevent.stop)="triggerRemove(contactGroup)"
                  portalDropdownItem
                  variant="danger"
                >
                  {{ 'generic.delete.entry' | portalTranslate }}
                </button>
              </portal-dropdown-menu>
            </ng-container>
          }
          <div>
            <span>{{ 'phoneBook.group.contacts' | translate }}:</span>
            <span class="badge text-bg-info ms-1">{{ contactGroup.entries.length }}</span>
          </div>
        </portal-card>
      }
    </div>
  </div>
</portal-loading-indicator-container>
